(function() {
	'use strict';

	/**
	 * @ngdoc object
	 * @name flightPunctuality.controller:FlightPunctualityCtrl
	 *
	 * @description
	 *
	 */
	angular.module('flightPunctuality').controller('FlightPunctualityCtrl', FlightPunctualityCtrl);

	function FlightPunctualityCtrl(CommonMasterData, FlightWatch, MessageService, EventManagerService, applicationConstants,
			FlightPunctualityRequestFactory, PopupManager, FlightPunctualityService, CrewingHelper, $window, $timeout) {
		var vm = this;
		vm.ctrlName = 'FlightPunctualityCtrl';
		vm.view = "FLIGHT_PUNCTUALITY";
		vm.model = {
      width: window.screen.width,
      height:window.screen.height,
			airports: [],
			delayCodeDetails:[],
            fuelSuppliers:[],
			masterList : {
				airportList : [],
        flightStatusList :[],
				crewTypes : [],
				profileTT : [],
        aircraftTypes :[],
				delayCodesTT : [],
				canvasHeight : 0,
				canvasWidth : 0,
				fromDateFormatInvalid : false,
				toDateFormatInvalid : false,
				fromDateAfterToDate : false,
				tab : 1,
			},
			searchCriteria : {
				fromDate : moment().format('DD/MM/YYYY'),
				toDate : moment().format('DD/MM/YYYY'),
        fromTime : "00:00",
        toTime : "23:59",
				origin : null,
        fleet : null,
				destination : null,
        status : null,
        flightNo : null,
				pageSize : 150,
				startPosition : 1,
        aeroOpsEnableParam : null,
			},
			searchPanelToggle : true,
			depaturePanelToggle : true,
			arrivalPanelToggle : true,
			interPanelToggle : true,
			flightData : {
				departureFlights : [],
				arrivalFlights : [],
				intermediateFlights : [],
				totalRecords : null,
			},
      showDeparture:true,
      showArrival:true,
      showIntermediate:true,
      aeroOpsEnableParam:false,
		};

		var cHeaders = [];
	  var dataObjectDeparture = [];
    var hotSettingsDeparture = [];
    var hotDeparture;

    var dataObjectArrival = [];
    var hotSettingsArrival = [];
    var hotArrival;

    var dataObject = [];
    var hotSettings = [];
    var hot;


    function initDivMeasurements() {
			$timeout(function(){
				//70 (title bar height) + 40 (toolbar height)
				vm.heightSearchPanel = 70 + angular.element('.flight-punctuality-view').height();
				//70 (title bar height) + 40 (toolbar height)+ 55 (tab header)+47 (grid table header height)
				vm.heightGridData = 70 + angular.element('.flight-punctuality-view').height() + 55 + 47;
				updateDivMeasurements();
			})
		}

		function updateDivMeasurements() {
			$timeout(function(){
				angular.element('.search-panel').css("max-height", $window.innerHeight - vm.heightSearchPanel);
				vm.model.masterList.canvasHeight = $window.innerHeight - vm.heightGridData;
				//70 (Side panel)
				vm.model.masterList.canvasWidth = $window.innerWidth - 70;
			})
		}

		angular.element($window).bind('resize', function(){
			initDivMeasurements();
        });

		vm.popUpDetails = {};
        vm.popUpDetails.airCraftDetails = '';
        vm.popUpDetails.relatedAirCraft = '';
        vm.popUpDetails.approachTypes = '';

		EventManagerService.registerEventListener(EventManagerService.EVENT.DO_ELASTIC_SEARCH,getNextSetOfRecords);

		EventManagerService.registerEventListener(EventManagerService.EVENT.TOOLBAR.FLIGHTPUNCTUALITY.DELAY_CODES,getDelayCodes);

		EventManagerService.registerEventListener(EventManagerService.EVENT.TOOLBAR.FLIGHTPUNCTUALITY.CREW_DETAILS,getcrewDetails);

		EventManagerService.registerEventListener(EventManagerService.EVENT.TOOLBAR.FLIGHTPUNCTUALITY.SEND_LIDO,sendLidoWAB);

		EventManagerService.registerEventListener(EventManagerService.EVENT.TOOLBAR.FLIGHTPUNCTUALITY.FLIGHT_LOG,getFlightLogDetails);

		EventManagerService.registerEventListener(EventManagerService.EVENT.TOOLBAR.FLIGHTPUNCTUALITY.SMS,onSendSmsListener);

		EventManagerService.registerEventListener(EventManagerService.EVENT.TOOLBAR.FLIGHTPUNCTUALITY.LIDO,onLidoListener);

		EventManagerService.registerEventListener(EventManagerService.EVENT.TOOLBAR.FLIGHTPUNCTUALITY.EDIT,onEditFlightListener);



		vm.clickOnSearch = function() {
			vm.model.searchPanelToggle = !vm.model.searchPanelToggle;
		};

    vm.clickOnSearch = function(tableName) {
      if(tableName ===  'departure') {
        vm.model.depaturePanelToggle = !vm.model.depaturePanelToggle;
      }else if(tableName ===  'arrival') {
        vm.model.arrivalPanelToggle = !vm.model.arrivalPanelToggle;
      }else if(tableName ===  'intermediate') {
        vm.model.interPanelToggle = !vm.model.interPanelToggle;
      }
    };

		vm.tabClick = function(tabId) {
			vm.model.masterList.tab = tabId;
			if(vm.scrollToTop){
				$timeout(function(){
					if(document.querySelector('.departureFlights') != null) {
						document.querySelector('.departureFlights').scrollTop = 0;
					}
					if(document.querySelector('.arrivalFlights') != null) {
						document.querySelector('.arrivalFlights').scrollTop = 0;
					}
					if(document.querySelector('.intermediateFlights') != null) {
						document.querySelector('.intermediateFlights').scrollTop = 0;
					}
				})
				vm.scrollToTop = false;
			}
			if(!!vm.model.selectedRowData) {
				vm.model.selectedRowData.isSelected = false;
	    		vm.model.selectedRowData = undefined;
			}
		};

		vm.changeSearchField = function(searchParams, flag) {
			if (flag === 'fromDate') {
				setDateValidationFlags();
				if (vm.model.searchCriteria.fromDate) {

                    var moEnd = moment(vm.model.searchCriteria.fromDate, applicationConstants.SETTINGS.DATE_FORMAT);
                    vm.model.searchCriteria.toDate = moEnd.format(applicationConstants.SETTINGS.DATE_FORMAT);
                }
			}
		};

		vm.selectMainGridRow = function(selectedRowData, flag) {
			if (flag === 'rowSelect') {
				if (!!vm.model.selectedRowData && vm.model.selectedRowData != selectedRowData) {
					vm.model.selectedRowData.isSelected = false;
				}
				vm.model.selectedRowData = selectedRowData;
				vm.model.selectedRowData.isSelected = true;
			}
			if (selectedRowData == undefined) {
				return;
			}
			if (flag === 'crewHover') {
				CrewingHelper.getCrewImgUrl(selectedRowData.crewProfileId, function(imageUrl) {
					selectedRowData.profileImageUrl = imageUrl;
					var crewType = _.find(vm.model.crewTypes,{crewTypeCode : selectedRowData.crewTypeCode});
					if (!!crewType) {
						selectedRowData.crewType = crewType.crewTypeDescription;
					}
					vm.model.masterList.profileTT = selectedRowData;
				}, function(error) {

				});
			} else if(flag === 'delayDepartureHover') {
				var delays = "", reasons = "";
				angular.forEach(selectedRowData.departureDelays, function(departureDelay){
					delays += departureDelay.delay + ", ";
					reasons += departureDelay.delayDescription + ", ";
				})
				if(delays.length > 0) {
					delays = delays.substring(0, delays.length-2);
					reasons = reasons.substring(0, reasons.length-2);
				}
				vm.model.masterList.delayCodesTT = {
						delay : delays,
						reason: reasons
				}
			} else if(flag === 'delayArrivalHover') {
				var delays = "", reasons = "";
				angular.forEach(selectedRowData.arrivalDelays, function(arrivalDelay){
					delays += arrivalDelay.delay + ", ";
					reasons += arrivalDelay.delayDescription + ", ";
				})
				if(delays.length > 0) {
					delays = delays.substring(0, delays.length-2);
					reasons = reasons.substring(0, reasons.length-2);
				}
				vm.model.masterList.delayCodesTT = {
						delay : delays,
						reason: reasons
				}
			} else if(flag == "statusON"){
				var time = selectedRowData.actualArrivalTime;
				vm.model.masterList.statusTT = {
						status : "ON",
						time : time,
						visiblity : true
				};
			} else if(flag == "statusOFF"){
				var time = selectedRowData.takeOffTime;
				vm.model.masterList.statusTT = {
						status : "OFF",
						time : time,
						visiblity : true
				};
			} else if(flag == "statusIN"){
				var time = selectedRowData.landingTime;
				vm.model.masterList.statusTT = {
						status : "IN",
						time : time,
						visiblity : true
				};
			} else if(flag == "statusOUT") {
				var time = selectedRowData.actualDepartureTime;
				vm.model.masterList.statusTT = {
						status : "OUT",
						time : time,
						visiblity : true
				};
			} else if(flag === 'delayCodeHover') {
				var delays = "", reasons = "";
				delays = selectedRowData.delay + "(" + selectedRowData.delayCode + ")";
				reasons = selectedRowData.delayDescription;
				vm.model.masterList.delayCodesTT = {
						delay : delays,
						reason: reasons
				}
			}

		};

		vm.submitSearch = function(params , isInitialLoad) {
			if(!isValidSearchParams()) {
				return;
			}
			vm.model.searchCriteria = params;
			if(document.querySelector('.departureFlights') != null) {
				document.querySelector('.departureFlights').scrollTop = 0;
			}
			if(document.querySelector('.arrivalFlights') != null) {
				document.querySelector('.arrivalFlights').scrollTop = 0;
			}
			if(document.querySelector('.intermediateFlights') != null) {
				document.querySelector('.intermediateFlights').scrollTop = 0;
			}
			vm.scrollToTop = true;
			vm.model.searchCriteria.startPosition = 1;
			//Creating copies of searchCreteria to get next set of records.
			vm.model.searchCriteriaDeparture = angular.copy(vm.model.searchCriteria);
			vm.model.searchCriteriaArrival = angular.copy(vm.model.searchCriteria);
			vm.model.searchCriteriaIntermediate = angular.copy(vm.model.searchCriteria);
      var enableAeroOps = vm.model.searchCriteria.aeroOpsEnableParam;
			getDepartureFlightData(isInitialLoad, enableAeroOps.paramValue);
			getArrivalFlightData(isInitialLoad, enableAeroOps.paramValue);
			getIntermediateFlightData(isInitialLoad, enableAeroOps.paramValue);
			if(!!vm.model.selectedRowData) {
				vm.model.selectedRowData.isSelected = false;
        		vm.model.selectedRowData = undefined;
			}
		};

		vm.openUpdateFlightPopUp = function () {
            PopupManager.openModal('FLIGHT_UPDATE_POPUP', vm.popUpDetails, function(param){
            	if(!!param) {
            		vm.model.selectedRowData.isSelected = false;
            		vm.model.selectedRowData = undefined;
            	}
             });
        };

        function isValidSearchParams() {
			setDateValidationFlags();
			// if date invalid
			if(!isFromDateBeforeToDate()) {
				vm.model.masterList.fromDateAfterToDate = true;
			} else {
				vm.model.masterList.fromDateAfterToDate = false;
			}

			if (vm.model.masterList.toDateFormatInvalid
					|| vm.model.masterList.fromDateFormatInvalid
					|| vm.model.masterList.fromDateAfterToDate) {
				return false;
			} else {
				return true;
			}
		}

		function setDateValidationFlags() {
			// if from date invalid
			if (isDateFormatInvalid(vm.model.searchCriteria.fromDate)) {
				vm.model.masterList.fromDateFormatInvalid = true;
			} else {
				vm.model.masterList.fromDateFormatInvalid = false;
			}
			// if to date invalid
			if (isDateFormatInvalid(vm.model.searchCriteria.toDate)) {
				vm.model.masterList.toDateFormatInvalid = true;
			} else {
				vm.model.masterList.toDateFormatInvalid = false;
			}
		}

		// check from date and to date
		function isFromDateBeforeToDate() {
			return moment(vm.model.searchCriteria.fromDate,"DD/MM/YYYY").isBefore( moment(vm.model.searchCriteria.toDate, "DD/MM/YYYY"))
			|| moment(vm.model.searchCriteria.fromDate,"DD/MM/YYYY").isSame(moment(vm.model.searchCriteria.toDate, "DD/MM/YYYY"));
		};

		// validate Date
		function isDateFormatInvalid(date) {
			if (!!date && !moment(date, "DD/MM/YYYY").isValid()) {
				return true;
			}
			return false;
		}


		function getToolbarContent() {
			if ($(".tabbed-view-container").height() == 0) {
				$(".tabbed-view-container").height(80);
			}
			var height = ($("header").height() + $(".tabbed-view-container").height()) + "px";
			$(".canvas").css("top", height);
		}


    vm.yellowRendererDepature = function (instance, td, row, col, prop, value) {
      if (vm.model.flightData.departureFlights != null) {
        if (col == 7){
          if (vm.model.flightData.departureFlights.flightPunctualityDTOSDeparture[row].delayTimeInMinsScheduledDeparture < 15 &&
            vm.model.flightData.departureFlights.flightPunctualityDTOSDeparture[row].delayTimeInMinsScheduledDeparture > 0) {
            Handsontable.renderers.TextRenderer.apply(this, arguments);
            td.style.backgroundColor = 'yellow';

          } else if (vm.model.flightData.departureFlights.flightPunctualityDTOSDeparture[row].delayTimeInMinsScheduledDeparture >= 15) {
            Handsontable.renderers.TextRenderer.apply(this, arguments);
            td.style.backgroundColor = '#FF6666';

          } else {
            Handsontable.renderers.TextRenderer.apply(this, arguments);
            td.style.backgroundColor = 'white';
          }
        }else if (col == 14){
          if (vm.model.flightData.departureFlights.flightPunctualityDTOSDeparture[row].delayTimeInMinsScheduledArrival < 15 &&
            vm.model.flightData.departureFlights.flightPunctualityDTOSDeparture[row].delayTimeInMinsScheduledArrival > 0) {
            Handsontable.renderers.TextRenderer.apply(this, arguments);
            td.style.backgroundColor = 'yellow';

          } else if (vm.model.flightData.departureFlights.flightPunctualityDTOSDeparture[row].delayTimeInMinsScheduledArrival >=15) {
            Handsontable.renderers.TextRenderer.apply(this, arguments);
            td.style.backgroundColor = '#FF6666';

          } else {
            Handsontable.renderers.TextRenderer.apply(this, arguments);
            td.style.backgroundColor = 'white';
          }
        }else if (col == 19){
          if (vm.model.flightData.departureFlights.flightPunctualityDTOSDeparture[row].takeOffDate == null && vm.model.flightData.departureFlights.flightPunctualityDTOSDeparture[row].takeOffTime == null &&
            vm.model.flightData.departureFlights.flightPunctualityDTOSDeparture[row].landingDate == null && vm.model.flightData.departureFlights.flightPunctualityDTOSDeparture[row].landingTime == null) {
            Handsontable.renderers.TextRenderer.apply(this, arguments);
            td.style.backgroundColor = '#92CDDC';

          } else {
            Handsontable.renderers.TextRenderer.apply(this, arguments);
            td.style.backgroundColor = 'white';
          }

        }

      }
    };

    vm.yellowRendererArrival = function (instance, td, row, col, prop, value) {
      if (vm.model.flightData.arrivalFlights != null) {
        if (col == 7){
          if (vm.model.flightData.arrivalFlights.flightPunctualityDTOSArrival[row].delayTimeInMinsScheduledDeparture < 15 &&
            vm.model.flightData.arrivalFlights.flightPunctualityDTOSArrival[row].delayTimeInMinsScheduledDeparture > 0) {
            Handsontable.renderers.TextRenderer.apply(this, arguments);
            td.style.backgroundColor = 'yellow';

          } else if (vm.model.flightData.arrivalFlights.flightPunctualityDTOSArrival[row].delayTimeInMinsScheduledDeparture >= 15) {
            Handsontable.renderers.TextRenderer.apply(this, arguments);
            td.style.backgroundColor = '#FF6666';

          } else {
            Handsontable.renderers.TextRenderer.apply(this, arguments);
            td.style.backgroundColor = 'white';
          }
        }else if (col == 14){
          if (vm.model.flightData.arrivalFlights.flightPunctualityDTOSArrival[row].delayTimeInMinsScheduledArrival < 15 &&
            vm.model.flightData.arrivalFlights.flightPunctualityDTOSArrival[row].delayTimeInMinsScheduledArrival > 0) {
            Handsontable.renderers.TextRenderer.apply(this, arguments);
            td.style.backgroundColor = 'yellow';

          } else if (vm.model.flightData.arrivalFlights.flightPunctualityDTOSArrival[row].delayTimeInMinsScheduledArrival >=15) {
            Handsontable.renderers.TextRenderer.apply(this, arguments);
            td.style.backgroundColor = '#FF6666';

          } else {
            Handsontable.renderers.TextRenderer.apply(this, arguments);
            td.style.backgroundColor = 'white';
          }
        }else if (col == 19){
          if (vm.model.flightData.arrivalFlights.flightPunctualityDTOSArrival[row].takeOffDate == null && vm.model.flightData.arrivalFlights.flightPunctualityDTOSArrival[row].takeOffTime == null &&
            vm.model.flightData.arrivalFlights.flightPunctualityDTOSArrival[row].landingDate == null && vm.model.flightData.arrivalFlights.flightPunctualityDTOSArrival[row].landingTime == null) {
            Handsontable.renderers.TextRenderer.apply(this, arguments);
            td.style.backgroundColor = '#92CDDC';

          } else {
            Handsontable.renderers.TextRenderer.apply(this, arguments);
            td.style.backgroundColor = 'white';
          }

        }

      }
    };



    vm.yellowRendererIntermediate = function (instance, td, row, col, prop, value) {
      if (vm.model.flightData.intermediateFlights != null) {
        if (col == 7){
          if (vm.model.flightData.intermediateFlights.flightPunctualityDTOSIntermediate[row].delayTimeInMinsScheduledDeparture < 15 &&
            vm.model.flightData.intermediateFlights.flightPunctualityDTOSIntermediate[row].delayTimeInMinsScheduledDeparture > 0) {
            Handsontable.renderers.TextRenderer.apply(this, arguments);
            td.style.backgroundColor = 'yellow';

          } else if (vm.model.flightData.intermediateFlights.flightPunctualityDTOSIntermediate[row].delayTimeInMinsScheduledDeparture >= 15) {
            Handsontable.renderers.TextRenderer.apply(this, arguments);
            td.style.backgroundColor = '#FF6666';

          } else {
            Handsontable.renderers.TextRenderer.apply(this, arguments);
            td.style.backgroundColor = 'white';
          }
        }else if (col == 14){
          if (vm.model.flightData.intermediateFlights.flightPunctualityDTOSIntermediate[row].delayTimeInMinsScheduledArrival < 15 &&
            vm.model.flightData.intermediateFlights.flightPunctualityDTOSIntermediate[row].delayTimeInMinsScheduledArrival > 0) {
            Handsontable.renderers.TextRenderer.apply(this, arguments);
            td.style.backgroundColor = 'yellow';

          } else if (vm.model.flightData.intermediateFlights.flightPunctualityDTOSIntermediate[row].delayTimeInMinsScheduledArrival >=15) {
            Handsontable.renderers.TextRenderer.apply(this, arguments);
            td.style.backgroundColor = '#FF6666';

          } else {
            Handsontable.renderers.TextRenderer.apply(this, arguments);
            td.style.backgroundColor = 'white';
          }
        }else if (col == 19){
          if (vm.model.flightData.intermediateFlights.flightPunctualityDTOSIntermediate[row].takeOffDate == null && vm.model.flightData.intermediateFlights.flightPunctualityDTOSIntermediate[row].takeOffTime == null &&
            vm.model.flightData.intermediateFlights.flightPunctualityDTOSIntermediate[row].landingDate == null && vm.model.flightData.intermediateFlights.flightPunctualityDTOSIntermediate[row].landingTime == null) {
            Handsontable.renderers.TextRenderer.apply(this, arguments);
            td.style.backgroundColor = '#92CDDC';

          } else {
            Handsontable.renderers.TextRenderer.apply(this, arguments);
            td.style.backgroundColor = 'white';
          }

        }

      }
    };

    vm.greenRender = function (instance, td, row, col, prop, value) {
      Handsontable.renderers.TextRenderer.apply(this, arguments);
      td.style.backgroundColor = '#EBF1DD';
    };

    vm.fontColorRenderDepature = function (instance, td, row, col, prop, value) {
      if (vm.model.flightData.departureFlights != null) {
        if (vm.model.flightData.departureFlights.flightPunctualityDTOSDeparture[row].fontColor != " "){
          Handsontable.renderers.TextRenderer.apply(this, arguments);
          td.style.color = vm.model.flightData.departureFlights.flightPunctualityDTOSDeparture[row].fontColor;
        }
      }
    };

    vm.fontColorRenderArrival = function (instance, td, row, col, prop, value) {
      if (vm.model.flightData.arrivalFlights != null) {
        if (vm.model.flightData.arrivalFlights.flightPunctualityDTOSArrival[row].fontColor != " "){
          Handsontable.renderers.TextRenderer.apply(this, arguments);
          td.style.color = vm.model.flightData.arrivalFlights.flightPunctualityDTOSArrival[row].fontColor;
        }
      }
    };

    vm.fontColorRenderInterMediate = function (instance, td, row, col, prop, value) {
      if (vm.model.flightData.intermediateFlights != null) {
        if (vm.model.flightData.intermediateFlights.flightPunctualityDTOSIntermediate[row].fontColor != " "){
          Handsontable.renderers.TextRenderer.apply(this, arguments);
          td.style.color  = vm.model.flightData.intermediateFlights.flightPunctualityDTOSIntermediate[row].fontColor;
        }
      }
    };


    function getDepartureFlightData(isInitialLoad, enableAeroOps) {
			FlightPunctualityService.getDepartureFlightData(vm.model.searchCriteriaDeparture, function(flights) {
				vm.model.searchPanelToggle = false;
				vm.model.flightData.departureFlights = flights;
				vm.model.flightData.departureFlights.flightPunctualityDTOSDeparture = FlightPunctualityRequestFactory.getFormattedFlights(flights.flightPunctualityDTOSDeparture);

        dataObjectDeparture = vm.dataObjectDeparture();
        if (angular.equals(enableAeroOps,"Y")) {
          hotSettingsDeparture = vm.hotSettingsDepartureForAeroOps(isInitialLoad);
        } else {
          hotSettingsDeparture = vm.hotSettingsDeparture(isInitialLoad);
        }

        hotDeparture = new Handsontable(hotElementDeparture, hotSettingsDeparture);

				}, function(error) {
				MessageService.error(error);
			});
		}

    vm.dataObjectDeparture =function () {
      var dataObjectDeparture = [];
     setDepHeaders();
//      Object.assign(vm.model.flightData.departureFlights.flightPunctualityDTOSDeparture,cHeaders);

     vm.model.flightData.departureFlights.flightPunctualityDTOSDeparture.splice(0,0,cHeaders[0]);

     for (var i in vm.model.flightData.departureFlights.flightPunctualityDTOSDeparture) {
        dataObjectDeparture.push({
          //set headers i=0
          NUM:i==0?" ":i,
          DATE:vm.model.flightData.departureFlights.flightPunctualityDTOSDeparture[i].estimatedDepartureDate,
          REG:vm.model.flightData.departureFlights.flightPunctualityDTOSDeparture[i].aircraftRegistrationNumber,
          SAI:vm.model.flightData.departureFlights.flightPunctualityDTOSDeparture[i].flightNumber,
          ROUTE:vm.model.flightData.departureFlights.flightPunctualityDTOSDeparture[i].route,
          STD:vm.model.flightData.departureFlights.flightPunctualityDTOSDeparture[i].originalEstimatedDepartureTime,
          RSTD:vm.model.flightData.departureFlights.flightPunctualityDTOSDeparture[i].estimatedDepartureTime,
          ATD:vm.model.flightData.departureFlights.flightPunctualityDTOSDeparture[i].actualDepartureTime,
          TOFF:vm.model.flightData.departureFlights.flightPunctualityDTOSDeparture[i].takeOffTime,
          DLY:vm.model.flightData.departureFlights.flightPunctualityDTOSDeparture[i].delayTimeInMinsScheduledDeparture,
          DCODE:vm.model.flightData.departureFlights.flightPunctualityDTOSDeparture[i].departureDelays == "DLYCODE"? "DLYCODE":getDalayCodes(vm.model.flightData.departureFlights.flightPunctualityDTOSDeparture[i].departureDelays),
          TDOWN:vm.model.flightData.departureFlights.flightPunctualityDTOSDeparture[i].landingTime,
          STA:vm.model.flightData.departureFlights.flightPunctualityDTOSDeparture[i].originalEstimatedArrivalTime,
          RSTA:vm.model.flightData.departureFlights.flightPunctualityDTOSDeparture[i].estimatedArrivalTime,
          ATA:vm.model.flightData.departureFlights.flightPunctualityDTOSDeparture[i].actualArrivalTime,
          DLYb:vm.model.flightData.departureFlights.flightPunctualityDTOSDeparture[i].delayTimeInMinsScheduledArrival,
          DCODEb:vm.model.flightData.departureFlights.flightPunctualityDTOSDeparture[i].arrivalDelays=="DCODE" ?"DCODE" :getDalayCodes(vm.model.flightData.departureFlights.flightPunctualityDTOSDeparture[i].arrivalDelays),
          PAX:vm.model.flightData.departureFlights.flightPunctualityDTOSDeparture[i].totalPaxCount,
          FLTTIME:vm.model.flightData.departureFlights.flightPunctualityDTOSDeparture[i].flightDuration,
          BLK:vm.model.flightData.departureFlights.flightPunctualityDTOSDeparture[i].actualDuration,
          ACTYPE:vm.model.flightData.departureFlights.flightPunctualityDTOSDeparture[i].modelNumber,
          DEP_GATE:vm.model.flightData.departureFlights.flightPunctualityDTOSDeparture[i].departureGate,
          DEP_STAND:vm.model.flightData.departureFlights.flightPunctualityDTOSDeparture[i].departureStand,
          ARR_GATE:vm.model.flightData.departureFlights.flightPunctualityDTOSDeparture[i].arrivalGate,
          ARR_STAND:vm.model.flightData.departureFlights.flightPunctualityDTOSDeparture[i].arrivalStand,
          FLI:vm.model.flightData.departureFlights.flightPunctualityDTOSDeparture[i].flightLegId
        })
      }
    //  setDepHeaders();
      return dataObjectDeparture;
    };

    function setNumberColumn(a){

    }

    function setDepHeaders(){
      cHeaders = [];

             cHeaders.push({
          //set headers i=0
          estimatedDepartureDate:"DATE",
          aircraftRegistrationNumber:"Reg",
          flightNumber:"SAI",
          route:"ROUTE",
          originalEstimatedDepartureTime:"STD",
          estimatedDepartureTime:"RSTD",
          actualDepartureTime:"ATD",
          takeOffTime:"TOFF",
          delayTimeInMinsScheduledDeparture:"DLY",
          departureDelays:"DLYCODE",
          landingTime:"TDOWN",
          originalEstimatedArrivalTime:"STA",
          estimatedArrivalTime:"RSTA",
          actualArrivalTime:"ATA",
          delayTimeInMinsScheduledArrival:"DLY",
          arrivalDelays:"DCODE",
          totalPaxCount:"PAX",
          flightDuration:"FLTTIME",
          actualDuration:"BLK",
          modelNumber:"ACTYPE",
          departureGate:"DEP GATE",
          departureStand:"DEP STAND",
          arrivalGate:"ARR GATE",
          arrivalStand:"ARR STAND",

        })
    //  vm.model.flightData.departureFlights.flightPunctualityDTOSDeparture.unshift(cHeaders);
    //  Object.assign(vm.model.flightData.departureFlights.flightPunctualityDTOSDeparture,cHeaders);


    }
    vm.setDelayCodeHeader = function(){
      return "DLYCODE"
    }
    vm.setDelayHeader = function(){
      return ""
    }

		function getDalayCodes(delayCodesList) {
		  var delayCodes = "";
		  for (var i in delayCodesList){
		    delayCodes += delayCodesList[i].delay + "("+ delayCodesList[i].delayCode + ") "
      }
      return delayCodes;
    }

    vm.hotSettingsDeparture = function (isInitialLoad) {
      var hotSettingsDeparture = [];
      var hotSettingsDeparture = {
        data: dataObjectDeparture,
        undo: true,
        redo: true,
        copy: true,
        paste: true,
        copyRowsLimit: 1000000,
        colWidths: [40, 70, 55, 60, 75, 40, 45,45,45,40,70,45,45,45,45,40,70,40,45,45,50,55,60,55,60],

        cells: function(row, col) {
          var cellProperties = {};
          if (col === 3) {
            cellProperties.renderer = atcCallSignTooltipRendererForDeparture
          }
          return cellProperties;
        },

        contextMenu: !isInitialLoad ? false: {
          callback: function(key, selection, clickEvent) {
            // Common callback for all options
            console.log("hashontable data!! "+key, selection, clickEvent);
          },
          items: {
            "Delay": {
              name: function() {
                return '<b><font color="grey">Delay Codes</font></b>';
              },
              hidden: function() {
                return  (!((hotDeparture.getSelected(null)[0]==hotDeparture.getSelected(null)[2])&&(hotDeparture.getSelected(null)[1]==hotDeparture.getSelected(null)[3])))
              },
              callback: function(key, selection, clickEvent) {
                setTimeout(function() {
                  getDelayCodes();
                }, 0);
              }
            },
            "edit": {
              name: function() {
                return '<b><font color="grey">Edit</font></b>';
              },
              hidden: function() {
                return  (!((hotDeparture.getSelected(null)[0]==hotDeparture.getSelected(null)[2])&&(hotDeparture.getSelected(null)[1]==hotDeparture.getSelected(null)[3])))
              },
              callback: function(key, selection, clickEvent) {
                setTimeout(function() {
                  vm.model.selectedRowData = dataObjectDeparture[hotDeparture.getSelected(null)[2]];
                  vm.model.selectedRowData.flightLegId = dataObjectDeparture[hotDeparture.getSelected(null)[2]].FLI;
                  onEditFlightListener();
                }, 0);
              }
            },
            "sms": {
              name: function() {
                return '<b><font color="grey">SMS</font></b>';
              },
              hidden: function() {
                return  (!((hotDeparture.getSelected(null)[0]==hotDeparture.getSelected(null)[2])&&(hotDeparture.getSelected(null)[1]==hotDeparture.getSelected(null)[3])))
              },
              callback: function(key, selection, clickEvent) {
                setTimeout(function() {
                  vm.model.selectedRowData = dataObjectDeparture[hotDeparture.getSelected(null)[2]];
                  vm.model.selectedRowData.flightLegId = dataObjectDeparture[hotDeparture.getSelected(null)[2]].FLI;
                  onSendSmsListener();

                }, 0);
              }
            },
            "crewDetails": {
              name: function() {
                return '<b><font color="grey">Crew Details</font></b>';
              },
              hidden: function() {
                return  (!((hotDeparture.getSelected(null)[0]==hotDeparture.getSelected(null)[2])&&(hotDeparture.getSelected(null)[1]==hotDeparture.getSelected(null)[3])))
              },
              callback: function(key, selection, clickEvent) {
                setTimeout(function() {
                  // vm.model.selectedRowData.flightLegId = dataObject[hot.getSelected(null)[2]].FLI;
                  vm.model.selectedRowData = dataObjectDeparture[hotDeparture.getSelected(null)[2]];

                  getcrewDetails();
                }, 0);
              }
            },
            "lido": {
              name: function() {
                return '<b><font color="grey">Lido</font></b>';
              },
              hidden: function() {
                return  (!((hotDeparture.getSelected(null)[0]==hotDeparture.getSelected(null)[2])&&(hotDeparture.getSelected(null)[1]==hotDeparture.getSelected(null)[3])))
              },
              callback: function(key, selection, clickEvent) {
                setTimeout(function() {
                  //  t.getDataAtCell(1,1);
                  vm.model.selectedRowData = dataObjectDeparture[hotDeparture.getSelected(null)[2]];
                  sendLidoWAB();
                }, 0);
              }
            },
            "flightLog": {
              name: function() {
                return '<b><font color="grey">Flight Log</font></b>';
              },
              hidden: function() {
                return  (!((hotDeparture.getSelected(null)[0]==hotDeparture.getSelected(null)[2])&&(hotDeparture.getSelected(null)[1]==hotDeparture.getSelected(null)[3])))
              },
              callback: function(key, selection, clickEvent) {
                setTimeout(function() {
                  vm.model.selectedRowData = dataObjectDeparture[hotDeparture.getSelected(null)[2]];
                  getFlightLogDetails();
                }, 0);
              }
            }


          }
        },

        columns: [
          {data:'NUM',
            type:'numeric',
            readOnly:true

          },
          {
            data: 'DATE',
            type: 'text',
            readOnly: true
          },
          {
            data: 'REG',
            type: 'text',
            readOnly: true
          },
          {
            data: 'SAI',
            type: 'text',
            readOnly: true
          },
          {
            data: 'ROUTE',
            type: 'text',
            renderer: vm.fontColorRenderDepature,
            readOnly: true
          },
          {
            data: 'STD',
            type: 'text',
            readOnly: true
          },
          {
            data: 'RSTD',
            type: 'text',
            renderer: vm.greenRender,
            readOnly: true
          },
          {
            data: 'ATD',
            type: 'text',
            readOnly: true,
            renderer: vm.yellowRendererDepature,
            manualColumnResize:5

          },
          {
            data: 'TOFF',
            type: 'text',
            readOnly: true
          },
          {
            data: 'DLY',
            type: 'text',
            readOnly: true
          },
          {
            data: 'DCODE',
            type: 'text',
            readOnly: true,
          },
          {
            data: 'TDOWN',
            type: 'text',
            readOnly: true
          },
          {
            data: 'STA',
            type: 'text',
            readOnly: true
          },
          {
            data: 'RSTA',
            type: 'text',
            renderer: vm.greenRender,
            readOnly: true
          },
          {
            data: 'ATA',
            type: 'text',
            renderer: vm.yellowRendererDepature,
            readOnly: true
          },
          {
            data: 'DLYb',
            type: 'text',
            readOnly: true
          },
          {
            data: 'DCODEb',
            type: 'text',
            readOnly: true
          },
          {
            data: 'PAX',
            type: 'text',
            readOnly: true
          },
          {
            data: 'FLTTIME',
            type: 'text',
            readOnly: true
          },
          {
            data: 'BLK',
            type: 'text',
            renderer: vm.yellowRendererDepature,
            readOnly: true
          },
          {
            data: 'ACTYPE',
            type: 'text',
            readOnly: true
          },
          {
            data: 'DEP_GATE',
            type: 'text',
            readOnly: true
          },
          {
            data: 'DEP_STAND',
            type: 'text',
            readOnly: true
          },
          {
            data: 'ARR_GATE',
            type: 'text',
            readOnly: true
          },
          {
            data: 'ARR_STAND',
            type: 'text',
            readOnly: true
          }
        ],

        stretchH: 'all',
        width: 1510,
        autoWrapRow: true,
        height: vm.model.height * 0.20,
        rowHeaders: true
      };

      return hotSettingsDeparture;
    };

    vm.hotSettingsDepartureForAeroOps = function (isInitialLoad) {
      var hotSettingsDeparture = [];
      var hotSettingsDeparture = {
        data: dataObjectDeparture,
        undo: true,
        redo: true,
        copy: true,
        paste: true,
        copyRowsLimit: 1000000,
        colWidths: [40, 70, 55, 60, 75, 40, 45,45,45,40,70,45,45,45,45,40,70,40,45,45,50,55,60,55,60],

        cells: function(row, col) {
          var cellProperties = {};
          if (col === 3) {
            cellProperties.renderer = atcCallSignTooltipRendererForDeparture
          }
          return cellProperties;
        },
        columns: [
          {data:'NUM',
            type:'numeric',
            readOnly:true

          },
          {
            data: 'DATE',
            type: 'text',
            readOnly: true
          },
          {
            data: 'REG',
            type: 'text',
            readOnly: true
          },
          {
            data: 'SAI',
            type: 'text',
            readOnly: true
          },
          {
            data: 'ROUTE',
            type: 'text',
            renderer: vm.fontColorRenderDepature,
            readOnly: true
          },
          {
            data: 'STD',
            type: 'text',
            readOnly: true
          },
          {
            data: 'RSTD',
            type: 'text',
            renderer: vm.greenRender,
            readOnly: true
          },
          {
            data: 'ATD',
            type: 'text',
            readOnly: true,
            renderer: vm.yellowRendererDepature,
            manualColumnResize:5

          },
          {
            data: 'TOFF',
            type: 'text',
            readOnly: true
          },
          {
            data: 'DLY',
            type: 'text',
            readOnly: true
          },
          {
            data: 'DCODE',
            type: 'text',
            readOnly: true,
          },
          {
            data: 'TDOWN',
            type: 'text',
            readOnly: true
          },
          {
            data: 'STA',
            type: 'text',
            readOnly: true
          },
          {
            data: 'RSTA',
            type: 'text',
            renderer: vm.greenRender,
            readOnly: true
          },
          {
            data: 'ATA',
            type: 'text',
            renderer: vm.yellowRendererDepature,
            readOnly: true
          },
          {
            data: 'DLYb',
            type: 'text',
            readOnly: true
          },
          {
            data: 'DCODEb',
            type: 'text',
            readOnly: true
          },
          {
            data: 'PAX',
            type: 'text',
            readOnly: true
          },
          {
            data: 'FLTTIME',
            type: 'text',
            readOnly: true
          },
          {
            data: 'BLK',
            type: 'text',
            renderer: vm.yellowRendererDepature,
            readOnly: true
          },
          {
            data: 'ACTYPE',
            type: 'text',
            readOnly: true
          },
          {
            data: 'DEP_GATE',
            type: 'text',
            readOnly: true
          },
          {
            data: 'DEP_STAND',
            type: 'text',
            readOnly: true
          },
          {
            data: 'ARR_GATE',
            type: 'text',
            readOnly: true
          },
          {
            data: 'ARR_STAND',
            type: 'text',
            readOnly: true
          }
        ],

        stretchH: 'all',
        width: 1510,
        autoWrapRow: true,
        height: vm.model.height * 0.20,
        rowHeaders: true
      };

      return hotSettingsDeparture;
    };

		function getArrivalFlightData(isInitialLoad, enableAeroOps) {
			FlightPunctualityService.getArrivalFlightData(vm.model.searchCriteriaArrival, function(flights) {
				vm.model.searchPanelToggle = false;
				vm.model.flightData.arrivalFlights = flights;
				vm.model.flightData.arrivalFlights.flightPunctualityDTOSArrival = FlightPunctualityRequestFactory.getFormattedFlights(flights.flightPunctualityDTOSArrival);

        dataObjectArrival = vm.dataObjectArrival();
        if(angular.equals(enableAeroOps,'Y')){
          hotSettingsArrival = vm.hotSettingsArrivalForAeroOps(isInitialLoad);
        }else {
          hotSettingsArrival = vm.hotSettingsArrival(isInitialLoad);
        }
        hotArrival = new Handsontable(hotElementArrival, hotSettingsArrival);
        // setArrivalColorCodes();

				}, function(error) {
				MessageService.error(error);
			});
		}

    vm.dataObjectArrival =function () {
      var dataObjectArrival = [];

      setDepHeaders();
//      Object.assign(vm.model.flightData.arrivalFlights.flightPunctualityDTOSArrival,cHeaders);

      vm.model.flightData.arrivalFlights.flightPunctualityDTOSArrival.splice(0,0,cHeaders[0]);

      for (var i in vm.model.flightData.arrivalFlights.flightPunctualityDTOSArrival) {
        dataObjectArrival.push({
          NUM:i==0?" ":i,
          DATE:vm.model.flightData.arrivalFlights.flightPunctualityDTOSArrival[i].estimatedDepartureDate,
          REG:vm.model.flightData.arrivalFlights.flightPunctualityDTOSArrival[i].aircraftRegistrationNumber,
          SAI:vm.model.flightData.arrivalFlights.flightPunctualityDTOSArrival[i].flightNumber,
          ROUTE:vm.model.flightData.arrivalFlights.flightPunctualityDTOSArrival[i].route,
          STD:vm.model.flightData.arrivalFlights.flightPunctualityDTOSArrival[i].originalEstimatedDepartureTime,
          RSTD:vm.model.flightData.arrivalFlights.flightPunctualityDTOSArrival[i].estimatedDepartureTime,
          ATD:vm.model.flightData.arrivalFlights.flightPunctualityDTOSArrival[i].actualDepartureTime,
          TOFF:vm.model.flightData.arrivalFlights.flightPunctualityDTOSArrival[i].takeOffTime,
          DLY:vm.model.flightData.arrivalFlights.flightPunctualityDTOSArrival[i].delayTimeInMinsScheduledDeparture,
          DCODE:vm.model.flightData.arrivalFlights.flightPunctualityDTOSArrival[i].departureDelays == "DLYCODE"? "DLYCODE":getDalayCodes(vm.model.flightData.arrivalFlights.flightPunctualityDTOSArrival[i].departureDelays),
          TDOWN:vm.model.flightData.arrivalFlights.flightPunctualityDTOSArrival[i].landingTime,
          STA:vm.model.flightData.arrivalFlights.flightPunctualityDTOSArrival[i].originalEstimatedArrivalTime,
          RSTA:vm.model.flightData.arrivalFlights.flightPunctualityDTOSArrival[i].estimatedArrivalTime,
          ATA:vm.model.flightData.arrivalFlights.flightPunctualityDTOSArrival[i].actualArrivalTime,
          DLYb:vm.model.flightData.arrivalFlights.flightPunctualityDTOSArrival[i].delayTimeInMinsScheduledArrival,
          DCODEb:vm.model.flightData.arrivalFlights.flightPunctualityDTOSArrival[i].arrivalDelays=="DCODE" ?"DCODE" :getDalayCodes(vm.model.flightData.arrivalFlights.flightPunctualityDTOSArrival[i].arrivalDelays),
          PAX:vm.model.flightData.arrivalFlights.flightPunctualityDTOSArrival[i].totalPaxCount,
          FLTTIME:vm.model.flightData.arrivalFlights.flightPunctualityDTOSArrival[i].flightDuration,
          BLK:vm.model.flightData.arrivalFlights.flightPunctualityDTOSArrival[i].actualDuration,
          ACTYPE:vm.model.flightData.arrivalFlights.flightPunctualityDTOSArrival[i].modelNumber,
          DEP_GATE:vm.model.flightData.arrivalFlights.flightPunctualityDTOSArrival[i].departureGate,
          DEP_STAND:vm.model.flightData.arrivalFlights.flightPunctualityDTOSArrival[i].departureStand,
          ARR_GATE:vm.model.flightData.arrivalFlights.flightPunctualityDTOSArrival[i].arrivalGate,
          ARR_STAND:vm.model.flightData.arrivalFlights.flightPunctualityDTOSArrival[i].arrivalStand,
          FLI: vm.model.flightData.arrivalFlights.flightPunctualityDTOSArrival[i].flightLegId

        })
      }
      return dataObjectArrival;
    };

    vm.hotSettingsArrival = function (isInitialLoad) {
      var hotSettingsArrival = {
        data: dataObjectArrival,
        undo: true,
        redo: true,
        copy: true,
        paste: true,
        copyRowsLimit: 1000000,
        colWidths: [40, 70, 55, 60, 75, 40, 45,45,45,40,70,45,45,45,45,40,70,40,45,45,50,55,60,55,60],

        cells: function(row, col) {
          var cellProperties = {};
          if (col === 3) {
            cellProperties.renderer = atcCallSignTooltipRendererForArrival
          }
          return cellProperties;
        },

        contextMenu: !isInitialLoad ? false : {
          callback: function(key, selection, clickEvent) {
            // Common callback for all options
            console.log("hashontable data!! "+key, selection, clickEvent);
          },
          items: {
            "Delay": {
              name: function() {
                return '<b><font color="grey">Delay Codes</font></b>';
              },
              hidden: function() {
                return  (!((hotArrival.getSelected(null)[0]==hotArrival.getSelected(null)[2])&&(hotArrival.getSelected(null)[1]==hotArrival.getSelected(null)[3])))
              },
              callback: function(key, selection, clickEvent) {
                setTimeout(function() {
                  getDelayCodes();
                }, 0);
              }
            },
            "edit": {
              name: function() {
                return '<b><font color="grey">Edit</font></b>';
              },
              hidden: function() {
                return  (!((hotArrival.getSelected(null)[0]==hotArrival.getSelected(null)[2])&&(hotArrival.getSelected(null)[1]==hotArrival.getSelected(null)[3])))
              },
              callback: function(key, selection, clickEvent) {
                setTimeout(function() {
                  vm.model.selectedRowData = dataObjectArrival[hotArrival.getSelected(null)[2]];
                  vm.model.selectedRowData.flightLegId = dataObjectArrival[hotArrival.getSelected(null)[2]].FLI;
                  onEditFlightListener();
                }, 0);
              }
            },
            "sms": {
              name: function() {
                return '<b><font color="grey">SMS</font></b>';
              },
              hidden: function() {
                return  (!((hotArrival.getSelected(null)[0]==hotArrival.getSelected(null)[2])&&(hotArrival.getSelected(null)[1]==hotArrival.getSelected(null)[3])))
              },
              callback: function(key, selection, clickEvent) {
                setTimeout(function() {
                  vm.model.selectedRowData = dataObjectArrival[hotArrival.getSelected(null)[2]];
                  vm.model.selectedRowData.flightLegId = dataObjectArrival[hotArrival.getSelected(null)[2]].FLI;
                  onSendSmsListener();
                }, 0);
              }
            },
            "crewDetails": {
              name: function() {
                return '<b><font color="grey">Crew Details</font></b>';
              },
              hidden: function() {
                return  (!((hotArrival.getSelected(null)[0]==hotArrival.getSelected(null)[2])&&(hotArrival.getSelected(null)[1]==hotArrival.getSelected(null)[3])))
              },
              callback: function(key, selection, clickEvent) {
                setTimeout(function() {
                  // vm.model.selectedRowData.flightLegId = dataObject[hot.getSelected(null)[2]].FLI;
                  vm.model.selectedRowData = dataObjectArrival[hotArrival.getSelected(null)[2]];

                  getcrewDetails();
                }, 0);
              }
            },
            "lido": {
              name: function() {
                return '<b><font color="grey">Lido</font></b>';
              },
              hidden: function() {
                return  (!((hotArrival.getSelected(null)[0]==hotArrival.getSelected(null)[2])&&(hotArrival.getSelected(null)[1]==hotArrival.getSelected(null)[3])))
              },
              callback: function(key, selection, clickEvent) {
                setTimeout(function() {
                  //  t.getDataAtCell(1,1);

                  vm.model.selectedRowData = dataObjectArrival[hotArrival.getSelected(null)[2]];
                  sendLidoWAB();

                }, 0);
              }
            },
            "flightLog": {
              name: function() {
                return '<b><font color="grey">Flight Log</font></b>';
              },
              hidden: function() {
                return  (!((hotArrival.getSelected(null)[0]==hotArrival.getSelected(null)[2])&&(hotArrival.getSelected(null)[1]==hotArrival.getSelected(null)[3])))
              },
              callback: function(key, selection, clickEvent) {
                setTimeout(function() {
                  vm.model.selectedRowData = dataObjectArrival[hotArrival.getSelected(null)[2]];
                  getFlightLogDetails();
                }, 0);
              }
            }


          }
        },

        columns: [
          {data:'NUM',
            type:'numeric',
            readOnly:true

          },
          {
            data: 'DATE',
            type: 'text',
            readOnly: true
          },
          {
            data: 'REG',
            type: 'text',
            readOnly: true
          },
          {
            data: 'SAI',
            type: 'text',
            readOnly: true
          },
          {
            data: 'ROUTE',
            type: 'text',
            renderer: vm.fontColorRenderArrival,
            readOnly: true
          },
          {
            data: 'STD',
            type: 'text',
            readOnly: true
          },
          {
            data: 'RSTD',
            type: 'text',
            renderer: vm.greenRender,
            readOnly: true
          },
          {
            data: 'ATD',
            type: 'text',
            readOnly: true,
            renderer: vm.yellowRendererArrival,
            manualColumnResize:5

          },
          {
            data: 'TOFF',
            type: 'text',
            readOnly: true
          },
          {
            data: 'DLY',
            type: 'text',
            readOnly: true
          },
          {
            data: 'DCODE',
            type: 'text',
            readOnly: true,
          },
          {
            data: 'TDOWN',
            type: 'text',
            readOnly: true
          },
          {
            data: 'STA',
            type: 'text',
            readOnly: true
          },
          {
            data: 'RSTA',
            type: 'text',
            renderer: vm.greenRender,
            readOnly: true
          },
          {
            data: 'ATA',
            type: 'text',
            renderer: vm.yellowRendererArrival,
            readOnly: true
          },
          {
            data: 'DLYb',
            type: 'text',
            readOnly: true
          },
          {
            data: 'DCODEb',
            type: 'text',
            readOnly: true
          },
          {
            data: 'PAX',
            type: 'text',
            readOnly: true
          },
          {
            data: 'FLTTIME',
            type: 'text',
            readOnly: true
          },
          {
            data: 'BLK',
            type: 'text',
            renderer: vm.yellowRendererArrival,
            readOnly: true
          },
          {
            data: 'ACTYPE',
            type: 'text',
            readOnly: true
          },
          {
            data: 'DEP_GATE',
            type: 'text',
            readOnly: true
          },
          {
            data: 'DEP_STAND',
            type: 'text',
            readOnly: true
          },
          {
            data: 'ARR_GATE',
            type: 'text',
            readOnly: true
          },
          {
            data: 'ARR_STAND',
            type: 'text',
            readOnly: true
          }
        ],

        stretchH: 'all',
        width: 1510,
        autoWrapRow: true,
        height: vm.model.height * 0.20,
        rowHeaders: true


      };

      return hotSettingsArrival;
    };

    vm.hotSettingsArrivalForAeroOps = function (isInitialLoad) {
      var hotSettingsArrival = {
        data: dataObjectArrival,
        undo: true,
        redo: true,
        copy: true,
        paste: true,
        copyRowsLimit: 1000000,
        colWidths: [40, 70, 55, 60, 75, 40, 45,45,45,40,70,45,45,45,45,40,70,40,45,45,50,55,60,55,60],

        cells: function(row, col) {
          var cellProperties = {};
          if (col === 3) {
            cellProperties.renderer = atcCallSignTooltipRendererForArrival
          }
          return cellProperties;
        },

        columns: [
          {data:'NUM',
            type:'numeric',
            readOnly:true

          },
          {
            data: 'DATE',
            type: 'text',
            readOnly: true
          },
          {
            data: 'REG',
            type: 'text',
            readOnly: true
          },
          {
            data: 'SAI',
            type: 'text',
            readOnly: true
          },
          {
            data: 'ROUTE',
            type: 'text',
            renderer: vm.fontColorRenderArrival,
            readOnly: true
          },
          {
            data: 'STD',
            type: 'text',
            readOnly: true
          },
          {
            data: 'RSTD',
            type: 'text',
            renderer: vm.greenRender,
            readOnly: true
          },
          {
            data: 'ATD',
            type: 'text',
            readOnly: true,
            renderer: vm.yellowRendererArrival,
            manualColumnResize:5

          },
          {
            data: 'TOFF',
            type: 'text',
            readOnly: true
          },
          {
            data: 'DLY',
            type: 'text',
            readOnly: true
          },
          {
            data: 'DCODE',
            type: 'text',
            readOnly: true,
          },
          {
            data: 'TDOWN',
            type: 'text',
            readOnly: true
          },
          {
            data: 'STA',
            type: 'text',
            readOnly: true
          },
          {
            data: 'RSTA',
            type: 'text',
            renderer: vm.greenRender,
            readOnly: true
          },
          {
            data: 'ATA',
            type: 'text',
            renderer: vm.yellowRendererArrival,
            readOnly: true
          },
          {
            data: 'DLYb',
            type: 'text',
            readOnly: true
          },
          {
            data: 'DCODEb',
            type: 'text',
            readOnly: true
          },
          {
            data: 'PAX',
            type: 'text',
            readOnly: true
          },
          {
            data: 'FLTTIME',
            type: 'text',
            readOnly: true
          },
          {
            data: 'BLK',
            type: 'text',
            renderer: vm.yellowRendererArrival,
            readOnly: true
          },
          {
            data: 'ACTYPE',
            type: 'text',
            readOnly: true
          },
          {
            data: 'DEP_GATE',
            type: 'text',
            readOnly: true
          },
          {
            data: 'DEP_STAND',
            type: 'text',
            readOnly: true
          },
          {
            data: 'ARR_GATE',
            type: 'text',
            readOnly: true
          },
          {
            data: 'ARR_STAND',
            type: 'text',
            readOnly: true
          }
        ],

        stretchH: 'all',
        width: 1510,
        autoWrapRow: true,
        height: vm.model.height * 0.20,
        rowHeaders: true


      };

      return hotSettingsArrival;
    };



    function getIntermediateFlightData(isInitialLoad, enableAeroOps) {
			FlightPunctualityService.getIntermediateFlightData(vm.model.searchCriteriaIntermediate, function(flights) {
				vm.model.searchPanelToggle = false;
				vm.model.flightData.intermediateFlights = flights;
        vm.model.flightData.intermediateFlights.flightPunctualityDTOSIntermediate = FlightPunctualityRequestFactory.getFormattedFlights(flights.flightPunctualityDTOSIntermidiate);
        dataObject = vm.dataObject();
        if(angular.equals(enableAeroOps,"Y")){
          hotSettings = vm.hotSettingsForAeroOps(isInitialLoad);
        }else {
          hotSettings = vm.hotSettings(isInitialLoad);
        }
        hot = new Handsontable(hotElement, hotSettings);

        // setIntermediateColorCodes();

      }, function(error) {
				MessageService.error(error);
			});
		}

    vm.dataObject =function () {
      var dataObject = [];

      setDepHeaders();
//      Object.assign(vm.model.flightData.intermediateFlights.flightPunctualityDTOSIntermediate,cHeaders);
      vm.model.flightData.intermediateFlights.flightPunctualityDTOSIntermediate.splice(0,0,cHeaders[0]);

      for (var i in vm.model.flightData.intermediateFlights.flightPunctualityDTOSIntermediate) {
        dataObject.push({

          NUM:i==0?" ":i,
          DATE:vm.model.flightData.intermediateFlights.flightPunctualityDTOSIntermediate[i].estimatedDepartureDate,
          REG:vm.model.flightData.intermediateFlights.flightPunctualityDTOSIntermediate[i].aircraftRegistrationNumber,
          SAI:vm.model.flightData.intermediateFlights.flightPunctualityDTOSIntermediate[i].flightNumber,
          ROUTE:vm.model.flightData.intermediateFlights.flightPunctualityDTOSIntermediate[i].route,
          STD:vm.model.flightData.intermediateFlights.flightPunctualityDTOSIntermediate[i].originalEstimatedDepartureTime,
          RSTD:vm.model.flightData.intermediateFlights.flightPunctualityDTOSIntermediate[i].estimatedDepartureTime,
          ATD:vm.model.flightData.intermediateFlights.flightPunctualityDTOSIntermediate[i].actualDepartureTime,
          TOFF:vm.model.flightData.intermediateFlights.flightPunctualityDTOSIntermediate[i].takeOffTime,
          DLY:vm.model.flightData.intermediateFlights.flightPunctualityDTOSIntermediate[i].delayTimeInMinsScheduledDeparture,
          DCODE:vm.model.flightData.intermediateFlights.flightPunctualityDTOSIntermediate[i].departureDelays == "DLYCODE"? "DLYCODE":getDalayCodes(vm.model.flightData.intermediateFlights.flightPunctualityDTOSIntermediate[i].departureDelays),
          TDOWN:vm.model.flightData.intermediateFlights.flightPunctualityDTOSIntermediate[i].landingTime,
          STA:vm.model.flightData.intermediateFlights.flightPunctualityDTOSIntermediate[i].originalEstimatedArrivalTime,
          RSTA:vm.model.flightData.intermediateFlights.flightPunctualityDTOSIntermediate[i].estimatedArrivalTime,
          ATA:vm.model.flightData.intermediateFlights.flightPunctualityDTOSIntermediate[i].actualArrivalTime,
          DLYb:vm.model.flightData.intermediateFlights.flightPunctualityDTOSIntermediate[i].delayTimeInMinsScheduledArrival,
          DCODEb:vm.model.flightData.intermediateFlights.flightPunctualityDTOSIntermediate[i].arrivalDelays=="DCODE" ?"DCODE" :getDalayCodes(vm.model.flightData.intermediateFlights.flightPunctualityDTOSIntermediate[i].arrivalDelays),
          PAX:vm.model.flightData.intermediateFlights.flightPunctualityDTOSIntermediate[i].totalPaxCount,
          FLTTIME:vm.model.flightData.intermediateFlights.flightPunctualityDTOSIntermediate[i].flightDuration,
          BLK:vm.model.flightData.intermediateFlights.flightPunctualityDTOSIntermediate[i].actualDuration,
          ACTYPE:vm.model.flightData.intermediateFlights.flightPunctualityDTOSIntermediate[i].modelNumber,
          DEP_GATE:vm.model.flightData.intermediateFlights.flightPunctualityDTOSIntermediate[i].departureGate,
          DEP_STAND:vm.model.flightData.intermediateFlights.flightPunctualityDTOSIntermediate[i].departureStand,
          ARR_GATE:vm.model.flightData.intermediateFlights.flightPunctualityDTOSIntermediate[i].arrivalGate,
          ARR_STAND:vm.model.flightData.intermediateFlights.flightPunctualityDTOSIntermediate[i].arrivalStand,
          FLI: vm.model.flightData.intermediateFlights.flightPunctualityDTOSIntermediate[i].flightLegId

        })
      }
      return dataObject;
    };

    vm.hotSettings = function (isInitialLoad) {
      var hotSettings = {
        data: dataObject,
        undo: true,
        redo: true,
        copy: true,
        paste: true,
        copyRowsLimit: 1000000,
        colWidths: [40, 70, 55, 60, 75, 40, 45,45,45,40,70,45,45,45,45,40,70,40,45,45,50,55,60,55,60],
        manualColumnResize: true,

        cells: function(row, col) {
          var cellProperties = {};
          if (col === 3) {
            cellProperties.renderer = atcCallSignTooltipRendererForIntermediate
          }
          return cellProperties;
        },

        contextMenu: !isInitialLoad ? false: {
          callback: function(key, selection, clickEvent) {
            // Common callback for all options
            console.log("hashontable data!! "+key, selection, clickEvent);
          },
          items: {
             "Delay": {
              name: function() {
                return '<b><font color="grey">Delay Codes</font></b>';
              },
              hidden: function() {
               return  (!((hot.getSelected(null)[0]==hot.getSelected(null)[2])&&(hot.getSelected(null)[1]==hot.getSelected(null)[3])))
              },
              callback: function(key, selection, clickEvent) {
                setTimeout(function() {
                  getDelayCodes();
                }, 0);
              }
            },
            "edit": {
              name: function() {
                return '<b><font color="grey">Edit</font></b>';
              },
              hidden: function() {
                return  (!((hot.getSelected(null)[0]==hot.getSelected(null)[2])&&(hot.getSelected(null)[1]==hot.getSelected(null)[3])))
              },
              callback: function(key, selection, clickEvent) {
                setTimeout(function() {
                  vm.model.selectedRowData = dataObject[hot.getSelected(null)[2]];
                  vm.model.selectedRowData.flightLegId = dataObject[hot.getSelected(null)[2]].FLI;
                  onEditFlightListener();
                }, 0);
              }
            },
            "sms": {
              name: function() {
                return '<b><font color="grey">SMS</font></b>';
              },
              hidden: function() {
                return  (!((hot.getSelected(null)[0]==hot.getSelected(null)[2])&&(hot.getSelected(null)[1]==hot.getSelected(null)[3])))
              },
              callback: function(key, selection, clickEvent) {
                setTimeout(function() {
                  vm.model.selectedRowData = dataObject[hot.getSelected(null)[2]];
                  vm.model.selectedRowData.flightLegId = dataObject[hot.getSelected(null)[2]].FLI;
                  onSendSmsListener();

                }, 0);
              }
            },
            "crewDetails": {
              name: function() {
                return '<b><font color="grey">Crew Details</font></b>';
              },
              hidden: function() {
                return  (!((hot.getSelected(null)[0]==hot.getSelected(null)[2])&&(hot.getSelected(null)[1]==hot.getSelected(null)[3])))
              },
              callback: function(key, selection, clickEvent) {
                setTimeout(function() {
                  vm.model.selectedRowData = dataObject[hot.getSelected(null)[2]];

                  getcrewDetails();
                }, 0);
              }
            },
            "lido": {
              name: function() {
                return '<b><font color="grey">Lido</font></b>';
              },
              hidden: function() {
                return  (!((hot.getSelected(null)[0]==hot.getSelected(null)[2])&&(hot.getSelected(null)[1]==hot.getSelected(null)[3])))
              },
              callback: function(key, selection, clickEvent) {
                setTimeout(function() {
                //  t.getDataAtCell(1,1);
                  vm.model.selectedRowData = dataObject[hot.getSelected(null)[2]];
                  sendLidoWAB();

                }, 0);
              }
            },
            "flightLog": {
              name: function() {
                return '<b><font color="grey">Flight Log</font></b>';
              },
              hidden: function() {
                return  (!((hot.getSelected(null)[0]==hot.getSelected(null)[2])&&(hot.getSelected(null)[1]==hot.getSelected(null)[3])))
              },
              callback: function(key, selection, clickEvent) {
                setTimeout(function() {
                  vm.model.selectedRowData = dataObject[hot.getSelected(null)[2]];
                  getFlightLogDetails();
                }, 0);
              }
            }


          }
        },

        columns: [
          {data:'NUM',
            type:'numeric',
            readOnly:true

          },
          {
            data: 'DATE',
            type: 'text',
            readOnly: true
          },
          {
            data: 'REG',
            type: 'text',
            readOnly: true
          },
          {
            data: 'SAI',
            type: 'text',
            readOnly: true
          },
          {
            data: 'ROUTE',
            renderer: vm.fontColorRenderInterMediate,
            type: 'text',

            readOnly: true
          },
          {
            data: 'STD',
            type: 'text',
            readOnly: true
          },
          {
            data: 'RSTD',
            type: 'text',
            renderer: vm.greenRender,
            readOnly: true
          },
          {
            data: 'ATD',
            type: 'text',
            readOnly: true,
            renderer: vm.yellowRendererIntermediate,
            manualColumnResize:5

          },
          {
            data: 'TOFF',
            type: 'text',
            readOnly: true
          },
          {
            data: 'DLY',
            type: 'text',
            readOnly: true
          },
          {
            data: 'DCODE',
            type: 'text',
            readOnly: true,
          },
          {
            data: 'TDOWN',
            type: 'text',
            readOnly: true
          },
          {
            data: 'STA',
            type: 'text',
            readOnly: true
          },
          {
            data: 'RSTA',
            type: 'text',
            renderer: vm.greenRender,
            readOnly: true
          },
          {
            data: 'ATA',
            type: 'text',
            renderer: vm.yellowRendererIntermediate,
            readOnly: true
          },
          {
            data: 'DLYb',
            type: 'text',
            readOnly: true
          },
          {
            data: 'DCODEb',
            type: 'text',
            readOnly: true
          },
          {
            data: 'PAX',
            type: 'text',
            readOnly: true
          },
          {
            data: 'FLTTIME',
            type: 'text',
            readOnly: true
          },
          {
            data: 'BLK',
            type: 'text',
            renderer: vm.yellowRendererIntermediate,
            readOnly: true
          },
          {
            data: 'ACTYPE',
            type: 'text',
            readOnly: true
          },
          {
            data: 'DEP_GATE',
            type: 'text',
            readOnly: true
          },
          {
            data: 'DEP_STAND',
            type: 'text',
            readOnly: true
          },
          {
            data: 'ARR_GATE',
            type: 'text',
            readOnly: true
          },
          {
            data: 'ARR_STAND',
            type: 'text',
            readOnly: true
          }
        ],

        stretchH: 'all',
        width: 1510,
        autoWrapRow: true,
        height: vm.model.height * 0.20,
        rowHeaders: true

      };

      return hotSettings;
    };

    vm.hotSettingsForAeroOps = function (isInitialLoad) {
      var hotSettings = {
        data: dataObject,
        undo: true,
        redo: true,
        copy: true,
        paste: true,
        copyRowsLimit: 1000000,
        colWidths: [40, 70, 55, 60, 75, 40, 45,45,45,40,70,45,45,45,45,40,70,40,45,45,50,55,60,55,60],
        manualColumnResize: true,

        cells: function(row, col) {
          var cellProperties = {};
          if (col === 3) {
            cellProperties.renderer = atcCallSignTooltipRendererForIntermediate
          }
          return cellProperties;
        },

        columns: [
          {data:'NUM',
            type:'numeric',
            readOnly:true

          },
          {
            data: 'DATE',
            type: 'text',
            readOnly: true
          },
          {
            data: 'REG',
            type: 'text',
            readOnly: true
          },
          {
            data: 'SAI',
            type: 'text',
            readOnly: true
          },
          {
            data: 'ROUTE',
            renderer: vm.fontColorRenderInterMediate,
            type: 'text',

            readOnly: true
          },
          {
            data: 'STD',
            type: 'text',
            readOnly: true
          },
          {
            data: 'RSTD',
            type: 'text',
            renderer: vm.greenRender,
            readOnly: true
          },
          {
            data: 'ATD',
            type: 'text',
            readOnly: true,
            renderer: vm.yellowRendererIntermediate,
            manualColumnResize:5

          },
          {
            data: 'TOFF',
            type: 'text',
            readOnly: true
          },
          {
            data: 'DLY',
            type: 'text',
            readOnly: true
          },
          {
            data: 'DCODE',
            type: 'text',
            readOnly: true,
          },
          {
            data: 'TDOWN',
            type: 'text',
            readOnly: true
          },
          {
            data: 'STA',
            type: 'text',
            readOnly: true
          },
          {
            data: 'RSTA',
            type: 'text',
            renderer: vm.greenRender,
            readOnly: true
          },
          {
            data: 'ATA',
            type: 'text',
            renderer: vm.yellowRendererIntermediate,
            readOnly: true
          },
          {
            data: 'DLYb',
            type: 'text',
            readOnly: true
          },
          {
            data: 'DCODEb',
            type: 'text',
            readOnly: true
          },
          {
            data: 'PAX',
            type: 'text',
            readOnly: true
          },
          {
            data: 'FLTTIME',
            type: 'text',
            readOnly: true
          },
          {
            data: 'BLK',
            type: 'text',
            renderer: vm.yellowRendererIntermediate,
            readOnly: true
          },
          {
            data: 'ACTYPE',
            type: 'text',
            readOnly: true
          },
          {
            data: 'DEP_GATE',
            type: 'text',
            readOnly: true
          },
          {
            data: 'DEP_STAND',
            type: 'text',
            readOnly: true
          },
          {
            data: 'ARR_GATE',
            type: 'text',
            readOnly: true
          },
          {
            data: 'ARR_STAND',
            type: 'text',
            readOnly: true
          }
        ],

        stretchH: 'all',
        width: 1510,
        autoWrapRow: true,
        height: vm.model.height * 0.20,
        rowHeaders: true

      };

      return hotSettings;
    };

    function atcCallSignTooltipRendererForDeparture(instance, td, row, col, prop, value, cellProperties) {
      Handsontable.renderers.TextRenderer.apply(this, arguments);

      if(row > 0){
        var atcCallSign = vm.model.flightData.departureFlights.flightPunctualityDTOSDeparture[row].atcCallSign;
        var atcAdHocCallSign = vm.model.flightData.departureFlights.flightPunctualityDTOSDeparture[row].atcAdHocCallSign;

        if(atcAdHocCallSign){
          td.title = value + ' ( ' + atcAdHocCallSign + ' * )';
        } else if (atcCallSign){
          td.title = value + ' ( ' + atcCallSign + ' )';
        } else {
          td.title = value ;
        }
      }
    }

    function atcCallSignTooltipRendererForArrival(instance, td, row, col, prop, value, cellProperties) {
      Handsontable.renderers.TextRenderer.apply(this, arguments);

      if(row > 0){
        var atcCallSign = vm.model.flightData.arrivalFlights.flightPunctualityDTOSArrival[row].atcCallSign;
        var atcAdHocCallSign = vm.model.flightData.arrivalFlights.flightPunctualityDTOSArrival[row].atcAdHocCallSign;

        if(atcAdHocCallSign){
          td.title = value + ' ( ' + atcAdHocCallSign + ' * )';
        } else if (atcCallSign){
          td.title = value + ' ( ' + atcCallSign + ' )';
        } else {
          td.title = value ;
        }
      }
    }

    function atcCallSignTooltipRendererForIntermediate(instance, td, row, col, prop, value, cellProperties) {
      Handsontable.renderers.TextRenderer.apply(this, arguments);

      if(row > 0){
        var atcCallSign = vm.model.flightData.intermediateFlights.flightPunctualityDTOSIntermediate[row].atcCallSign;
        var atcAdHocCallSign = vm.model.flightData.intermediateFlights.flightPunctualityDTOSIntermediate[row].atcAdHocCallSign;

        if(atcAdHocCallSign){
          td.title = value + ' ( ' + atcAdHocCallSign + ' * )';
        } else if (atcCallSign){
          td.title = value + ' ( ' + atcCallSign + ' )';
        } else {
          td.title = value ;
        }
      }
    }


    var hotElement = document.querySelector('#hot');

    var hotElementArrival = document.querySelector('#hotArrival');

    var hotElementDeparture = document.querySelector('#hotDeparture');

    vm.exportDeparture = function () {
      alasql("SELECT estimatedDepartureDate as [Date],aircraftRegistrationNumber as [Reg],flightNumber as [SAI],route as [ROUTE],originalEstimatedDepartureTime as [STD],estimatedDepartureTime as [RSTD],actualDepartureTime as [ATD],takeOffTime as [TOFF],delayTimeInMinsScheduledDeparture as [DLY],delayCode  as [DCODE],landingTime as [TDOWN],originalEstimatedArrivalTime as [STA],estimatedArrivalTime as [RSTA],actualArrivalTime as [ATA],delayTimeInMinsScheduledArrival as [DLY],delay as [DCODE],totalPaxCount as [PAX],flightDuration as [FLTTIME],actualDuration as [BLK],modelNumber as [ACTYPE], flightLegId as [FLI] INTO XLSX('flightDeparture.xlsx',{headers:true}) FROM ? ", [vm.model.flightData.departureFlights.flightPunctualityDTOSDeparture]);
     // clearData();
    };

    vm.exportArrival = function () {
      alasql("SELECT estimatedDepartureDate as [Date],aircraftRegistrationNumber as [Reg],flightNumber as [SAI],route as [ROUTE],originalEstimatedDepartureTime as [STD],estimatedDepartureTime as [RSTD],actualDepartureTime as [ATD],takeOffTime as [TOFF],delayTimeInMinsScheduledDeparture as [DLY],delayCode  as [DCODE],landingTime as [TDOWN],originalEstimatedArrivalTime as [STA],estimatedArrivalTime as [RSTA],actualArrivalTime as [ATA],delayTimeInMinsScheduledArrival as [DLY],delay as [DCODE],totalPaxCount as [PAX],flightDuration as [FLTTIME],actualDuration as [BLK],modelNumber as [ACTYPE], flightLegId as [FLI] INTO XLSX('flightDeparture.xlsx',{headers:true}) FROM ? ", [ vm.model.flightData.arrivalFlights.flightPunctualityDTOSArrival]);
      // clearData();
    };

    vm.exportIntermediate = function () {
      alasql("SELECT estimatedDepartureDate as [Date],aircraftRegistrationNumber as [Reg],flightNumber as [SAI],route as [ROUTE],originalEstimatedDepartureTime as [STD],estimatedDepartureTime as [RSTD],actualDepartureTime as [ATD],takeOffTime as [TOFF],delayTimeInMinsScheduledDeparture as [DLY],delayCode  as [DCODE],landingTime as [TDOWN],originalEstimatedArrivalTime as [STA],estimatedArrivalTime as [RSTA],actualArrivalTime as [ATA],delayTimeInMinsScheduledArrival as [DLY],delay as [DCODE],totalPaxCount as [PAX],flightDuration as [FLTTIME],actualDuration as [BLK],modelNumber as [ACTYPE], flightLegId as [FLI] INTO XLSX('flightDeparture.xlsx',{headers:true}) FROM ? ", [vm.model.flightData.intermediateFlights.flightPunctualityDTOSIntermediate]);
      // clearData();
    };


		function getDelayCodes() {
			PopupManager.openModal("DELAY_CODE", {delayCodes : vm.model.delayCodeDetails});
		}
    function getcrewDetails() {
      PopupManager.openModal("CREW_DETAILS", {flightLeg : vm.model.selectedRowData});
    }

    function getFlightLogDetails() {
      PopupManager.openModal("FLIGHT_LOG", {flightLeg : vm.model.selectedRowData});
    }

    function sendLido(){
      FlightPunctualityService.sendLIDOWABMessage(vm.model.selectedRowData.FLI, function(msg) {
        console.info("LIDO Sent");
        MessageService.success(msg);
      }, function(error) {
        MessageService.error(error);
      });
    }

    function sendLidoWAB(){
      var param = {
        title: 'Confirmation',
        messages: ["Lido messages will be sent for this flight.Are you sure?"],
        flags: vm.model.selectedRowData.FLI
      };
      PopupManager.openModal('CONFIRM_DIALOG', param, confirmLidoSent);
    }


    function confirmLidoSent(pass) {
      if(pass==='YES'){
        sendLido();
      }
    }

    function onEditFlightListener() {
			if (!!vm.model.selectedRowData) {
	            vm.selectedFlightLegId = vm.model.selectedRowData.flightLegId;
	            loadFightDetails();
			} else {
				MessageService.warning(MessageService.MESSAGES.CREWING.NO_SELECTION_WARNING);
			}
		}

		function onSendSmsListener() {
			if (!!vm.model.selectedRowData) {
				var params = {};
        params.isForBlock = true;
        params.isChecked = false;
        params.messageContent = FlightPunctualityService.getDutyInformation(vm.model.selectedRowData);

        FlightPunctualityService.getJoininigCrews(vm.model.selectedRowData.flightLegId, function(crews) {
					params.joiningCrew = crews.flightJoiningCrewList;
					angular.forEach(params.joiningCrew, function(crewObj){
						crewObj.crewProfileID = crewObj.crewProfileId;
					});
					PopupManager.openModal('SMS', params, function(param){
						if(!!param) {
							vm.model.selectedRowData.isSelected = false;
              vm.model.selectedRowData = undefined;
						}
          });
				}, function(error) {
					MessageService.error(error);
				});
			} else {
				MessageService.warning(MessageService.MESSAGES.CREWING.NO_SELECTION_WARNING);
			}
		}

		function onLidoListener() {
			var params = {};
			// PopupManager.openModal();
		};

		function loadFightDetails() {
        	FlightWatch.getAirCraftDetails(vm.selectedFlightLegId, function (response) {
        		vm.popUpDetails.airCraftDetails = response.flightDetResponceDto;
        		vm.popUpDetails.fuelSuppliers = vm.model.fuelSuppliers;
        		vm.popUpDetails.airports = vm.model.airports;
        		vm.popUpDetails.delayCodeDetails = response.delayCodeAdaptDTOs;
        		vm.popUpDetails.updateFlightSource = applicationConstants.UPDATE_FLIGHT_SOURCE.FLIGHT_PUNCTUALITY;
        		FlightWatch.loadAircraftListByCode(null, function (response) {
        			vm.popUpDetails.relatedAirCraft = response;
        			CommonMasterData.approachTypes(
    					function (response) {
    						vm.popUpDetails.approachTypes = response;
    						vm.openUpdateFlightPopUp();
    					}, function () {
        			});
        		},
        		function () {
        			console.log('Open Flight search retrieval error');
        		})
        	},
        	function (response) {

        	});
        };

		function getAeroOpsEnableParam(){
      CommonMasterData.getAeroOpsEnableParam(
        function (ep) {
          vm.model.searchCriteria.aeroOpsEnableParam = ep;
          // aeroOpsEnableParam = ep;
          vm.submitSearch(vm.model.searchCriteria , true)
        },
        function () {
          console.log('AeroOps Enable Param retrieval error');
        }
      );

    }

        function getNextSetOfRecords() {
        	var totalRecords = 0;
        	var searchCriteria = [];
        	if(vm.model.masterList.tab == 1) {
        		totalRecords = vm.model.flightData.departureFlights.totalRecords;
        		searchCriteria = vm.model.searchCriteriaDeparture;
        	} else if(vm.model.masterList.tab == 2) {
        		totalRecords = vm.model.flightData.arrivalFlights.totalRecords;
        		searchCriteria = vm.model.searchCriteriaArrival;
        	} else {
        		totalRecords = vm.model.flightData.intermediateFlights.totalRecords;
        		searchCriteria = vm.model.searchCriteriaIntermediate;
        	}

        	if (totalRecords && searchCriteria.startPosition + searchCriteria.pageSize < totalRecords) {
                searchCriteria.startPosition = searchCriteria.startPosition + searchCriteria.pageSize;
                getDataForElasticSearch();
	        } else {
				var lastPageStartPos = totalRecords - searchCriteria.pageSize;
                if (searchCriteria.startPosition < lastPageStartPos) {
                    searchCriteria.startPosition = lastPageStartPos;
                    getDataForElasticSearch();
                }
			}
		}

		function getDataForElasticSearch() {
			// if(vm.model.masterList.tab == 1) {
				FlightPunctualityService.getDepartureFlightData(vm.model.searchCriteriaDeparture, function(flights) {
					flights.flightPunctualityDTOSDeparture = FlightPunctualityRequestFactory.getFormattedFlights(flights.flightPunctualityDTOSDeparture);
					FlightPunctualityService.appendToGridFlightList(vm.model.flightData.departureFlights, flights, vm.model.masterList.tab);
				}, function(error) {
					MessageService.error(error);
				});
			// } else if(vm.model.masterList.tab == 2) {
				FlightPunctualityService.getArrivalFlightData(vm.model.searchCriteriaArrival, function(flights) {
					flights.flightPunctualityDTOSArrival = FlightPunctualityRequestFactory.getFormattedFlights(flights.flightPunctualityDTOSArrival);
					FlightPunctualityService.appendToGridFlightList(vm.model.flightData.arrivalFlights, flights, vm.model.masterList.tab);
				}, function(error) {
					MessageService.error(error);
				});
			// } else {
				FlightPunctualityService.getIntermediateFlightData(vm.model.searchCriteriaIntermediate, function(flights) {
					flights.flightPunctualityDTOSIntermediate = FlightPunctualityRequestFactory.getFormattedFlights(flights.flightPunctualityDTOSIntermidiate);
					FlightPunctualityService.appendToGridFlightList(vm.model.flightData.intermediateFlights, flights, vm.model.masterList.tab);
				}, function(error) {
					MessageService.error(error);
				});
			// }

		}
    function getUniqueRecords(aircrafts){
      var list =[];
      var uniqueList =[];
      _.each(aircrafts, function (obj) {
        if(!list.includes(obj.airCraftType)) {
          list.push(obj.airCraftType);
          uniqueList.push(obj);
        }
      });
      return uniqueList;
    }

		(function() {
			FlightPunctualityService.getDelayCodes(function(delayCodes) {
				vm.model.delayCodeDetails = delayCodes;
			}, function(error) {
				MessageService.error(error);
			});

			CommonMasterData.getAirportList(function(response) {
				vm.model.airports = response;
			}, function() {
				console.log('Airport list retrieval error');
			});

			CommonMasterData.getCrewTypeList(function(crewTypes) {
				vm.model.crewTypes = crewTypes;
			}, function() {
				console.log('Crew type retrieval error');
			});

      CommonMasterData.getFlightStatusList(function(flightStatusList) {
        vm.model.masterList.flightStatusList = flightStatusList;
      }, function(error) {
        console.log('Flight Status List retrieval error!!!');
      });

      CommonMasterData.getAircraftTypeList(
        function (aircrafts) {
          vm.model.masterList.aircraftTypes = getUniqueRecords(aircrafts);
        },
        function () {
          console.log('Aircraft type retrieval error');
        }
      );

			CommonMasterData.getAirportList(function(airportList) {
				vm.model.masterList.airportList = airportList;
			}, function() {
				console.log('Airport List retrieval error');
			});

      getAeroOpsEnableParam();
			getToolbarContent();
			initDivMeasurements();
		})();
	}
}());
